module.exports = __webpack_public_path__ + "img/187.68d25f51.jpg";